import {
  basicLogger,
  LDProvider,
  useLDClient,
  useLDClientError,
} from "launchdarkly-react-client-sdk";
import getConfig from "next/config";
import type { PropsWithChildren } from "react";
import * as React from "react";
import type { Event } from "src/types";

import { defaultFlags } from "./default-flags";

const { publicRuntimeConfig } = getConfig();

type LaunchDarklyIdentifyProps = {
  event: Event;
};

export function LaunchDarklyIdentify({ event }: LaunchDarklyIdentifyProps) {
  const ldClient = useLDClient();
  const ldClientError = useLDClientError();
  const { slug, organization } = event;

  React.useEffect(() => {
    const ldClientIsReady = typeof ldClient !== "undefined";
    if (ldClientIsReady && slug && !(ldClientError instanceof Error)) {
      ldClient.identify({
        key: slug as string,
        kind: "user",
        eventSlug: slug,
        organizationExternalId: organization.external_id,
        custom: {
          eventSlug: slug,
          organizationExternalId: organization.external_id,
        },
      });
    }
  }, [ldClient, slug, ldClientError, organization.external_id]);

  return null;
}

function FeatureFlags({ children }: PropsWithChildren) {
  return (
    <LDProvider
      clientSideID={publicRuntimeConfig.LAUNCH_DARKLY_CLIENT_KEY}
      context={context}
      options={{
        streaming: false,
        diagnosticOptOut: true,
        sendEvents: false,
        bootstrap: defaultFlags,
        fetchGoals: false,
        logger: basicLogger({ level: "warn" }),
      }}
    >
      <>{children}</>
    </LDProvider>
  );
}

const context = {
  kind: "user",
  key: "unknown-event",
};

export default FeatureFlags;
